import { UploadFile } from "./upload-file";

export class UploadFileData extends UploadFile {
    isUploadedOnServer: boolean;
    isRemoved: boolean = false;
    aiAnalyzed: boolean = false;
    isUploading: boolean = false;
}